import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { LeaveMessagePopup } from "../components/LeaveMessagePopup";
import { initializeI18n } from "../localization/i18n";

window.openLeaveMessagePopup = () =>
  console.warn("Leave-a-message popup is not ready yet…");

window.renderLeaveAMessagePopup = (elementId, props) => {
  const container = document.getElementById(elementId);
  if (!container) return //console.error(`Element #${elementId} not found`);

  initializeI18n()
    .then(() => {
      let show;
      window.openLeaveMessagePopup = (typeCode = null) => {
        if (show) show(typeCode);
        else console.warn("Leave-a-message popup is not ready yet…");
      };

      const Root = () => {
        const [visible, setVisible] = useState(false);
        const [initialType, setInitial] = useState(null);

        useEffect(() => {
          show = (typeCode) => {
            setInitial(typeCode);
            setVisible(true);
          };
        }, []);

        return (
          <LeaveMessagePopup
            visible={visible}
            onHide={() => setVisible(false)}
            initialTypeCode={initialType}
            popupProps={props.popup}
            invalidMessages={props.errorMessage}
          />
        );
      };

      ReactDOM.render(<Root />, container);
    });
};
